<template>
    <div id="sidenav" :style="cssVars">
        <div class="logo-wrap" :class="{ 'has-multiple-organisations': hasMultipleOrganisations }">
            <router-link :to="{ name: 'Dashboard' }">
                <img :src="user.organisation_logo ? user.organisation_logo : '/images/logo-planiteasy-v1.svg'" class="logo" @click="toggleCategory('dashboard')">
            </router-link>

            <OrganisationSwitcher v-if="user.organisations && Object.keys(user.organisations).length > 1"/>

            <div class="hamburger hide-for-large" @click="mobileNavOpen = !mobileNavOpen" :class="{ 'nav-open': mobileNavOpen }">
                <div class="nav-icon">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>

        </div>

        <slide-up-down :active="mobileNavOpen" :duration="300" style="height: 100%;">
            <div class="mobile-nav-wrap" v-show="mobileNavOpen" :key="key">
                <div>
                    <!-- Deurwaarder nav -->
                    <div class="nav-wrap" v-if="user && user.deurwaarder">
                        <router-link :to="{ name: 'InvoicesOverview', params: {type: 'geescaleerd'} }" class="parent" :class="{ 'active': activeCategory.escalatedinvoices }">
                            <li class="parent" @click="toggleCategory('escalatedinvoices')">
                                <div class="text-wrap" >
                                    <span class="text">Facturen</span>
                                    <b-icon icon="file-invoice"/>
                                </div>
                            </li>
                        </router-link>

                        <router-link :to="{ name: 'ContractsOverview' }" class="parent" :class="{ 'active': activeCategory.contracts }">
                            <li class="parent" @click="toggleCategory('contracts')">
                                <div class="text-wrap" >
                                    <span class="text">Contracten</span>
                                    <b-icon icon="file-alt"/>
                                </div>
                            </li>
                        </router-link>

                        <router-link :to="{ name: 'CustomersOverview' }" class="parent" :class="{ 'active': activeCategory.customers }">
                            <li class="parent" @click="toggleCategory('customers')">
                                <div class="text-wrap" >
                                    <span class="text">Klanten</span>
                                    <b-icon icon="user-friends"/>
                                </div>
                            </li>
                        </router-link>
                    </div>

                    <!-- Nav for everyone (except deurwaarder) -->
                    <div class="nav-wrap" v-else>
                        <router-link :to="{ name: 'Dashboard' }" class="parent" v-if="!hideDashboard" :class="{ 'active': activeCategory.dashboard }">
                            <li class="parent" @click="toggleCategory('dashboard')">
                                <div class="text-wrap" >
                                    <span class="text">Dashboard</span>
                                    <b-icon icon="tachometer-alt"/>
                                </div>
                            </li>
                        </router-link>

                        <ul class="parent" :class="{ 'active': activeCategory.company }">
                            <li class="parent">
                                <div class="text-wrap" @click="toggleCategory('company')">
                                    <span class="text has-chevron">Organisatie</span>
                                    <b-icon icon="chevron-down" class="arrow"/>
                                    <b-icon icon="user-shield" v-if="user && user.role == 'pit'"/>
                                    <b-icon icon="building" v-else/>
                                </div>

                                <slide-up-down :active="activeCategory.company" :duration="300">
                                    <ul class="submenu" v-if="user && user.role == 'pit'">
                                        <li><router-link :to="{ name: 'OrganisationsOverview' }">Organisaties</router-link></li>
                                        <li><router-link :to="{ name: 'AccountsOverview' }">Gebruikers</router-link></li>
                                        <li><router-link :to="{ name: 'CommunicationOverview' }">Communicatie</router-link></li>
                                        <li><router-link :to="{ name: 'OnlineRentalSettings' }">Online verhuren</router-link></li>
                                        <!-- <li><router-link :to="{ name: 'MailOverview' }">Klanten mailen</router-link></li> -->
                                        <!-- <li><router-link :to="{ name: 'DiscountsOverview' }">Kortingen<b-tag v-if="showDiscountNewBadge" type="is-success" size="is-small" style="margin-left: 0.25rem;">Nieuw</b-tag></router-link></li> -->
                                        <li><router-link :to="{ name: 'LogsOverview' }">Logs</router-link></li>
                                    </ul>
                                    <ul class="submenu" v-else>
                                        <li><router-link :to="{ name: 'OrganisationRecord', query: {company: 'me'} }">Instellingen</router-link></li>
                                        <li><router-link :to="{ name: 'AccountsOverview' }">Gebruikers</router-link></li>
                                        <li v-if="user.role != 'pit'"><router-link :to="{ name: 'CommunicationOverview' }">Communicatie</router-link></li>
                                        <li><router-link :to="{ name: 'OnlineRentalSettings' }">Online verhuren</router-link></li>
                                        <!-- <li><router-link :to="{ name: 'MailOverview' }">Klanten mailen</router-link></li> -->
                                        <!-- <li><router-link :to="{ name: 'DiscountsOverview' }">Kortingen<b-tag v-if="showDiscountNewBadge" type="is-success" size="is-small" style="margin-left: 0.25rem;">Nieuw</b-tag></router-link></li> -->
                                    </ul>
                                </slide-up-down>
                            </li>
                        </ul>

                        <div v-if="user.organisation_type === 'box' || user.role == 'pit'">
                            <router-link :to="{ name: 'BoxesOverview' }" class="parent" :class="{ 'active': activeCategory.boxes }">
                                <li class="parent" @click="toggleCategory('boxes')">
                                    <div class="text-wrap" >
                                        <span class="text">{{ boxOrMap == 'box' ? 'Boxen' : 'Plattegrond' }}</span>
                                        <b-icon :icon="boxOrMap == 'box' ? 'square' : 'map'"/>
                                    </div>
                                </li>
                            </router-link>
                        </div>

                        <router-link :to="{ name: 'MailOverview' }" class="parent" :class="{ 'active': activeCategory.mail }">
                            <li class="parent" @click="toggleCategory('mail')">
                                <div class="text-wrap" >
                                    <span class="text">Bericht sturen</span>
                                    <b-icon icon="envelope"/>
                                </div>
                            </li>
                        </router-link>

                        <router-link :to="{ name: 'DiscountsOverview' }" class="parent" :class="{ 'active': activeCategory.discounts }">
                            <li class="parent" @click="toggleCategory('discounts')">
                                <div class="text-wrap" >
                                    <span class="text">
                                        Kortingen
                                        <b-tag v-if="showDiscountNewBadge" type="is-success" size="is-small" style="margin-left: 0.25rem;">Nieuw</b-tag>
                                    </span>
                                    <b-icon icon="percent"/>
                                </div>
                            </li>
                        </router-link>

                        <router-link :to="{ name: 'ProductsOverview' }" class="parent" :class="{ 'active': activeCategory.products }">
                            <li class="parent" @click="toggleCategory('products')">
                                <div class="text-wrap" >
                                    <span class="text">Producten</span>
                                    <b-icon icon="box-open"/>
                                </div>
                            </li>
                        </router-link>

                        <ul class="parent" :class="{ 'active': activeCategory.contracts }">
                            <li class="parent">
                                <div class="text-wrap" @click="toggleCategory('contracts')">
                                    <span class="text has-chevron">Contracten</span>
                                    <b-icon icon="chevron-down" class="arrow"/>
                                    <b-icon icon="file-alt"/>
                                </div>

                                <slide-up-down :active="activeCategory.contracts" :duration="300">
                                    <ul class="submenu">
                                        <li><router-link :to="{ name: 'ContractsOverview' }">Contracten</router-link></li>
                                        <li><router-link :to="{ name: 'ContractsTemplates' }">Sjablonen</router-link></li>
                                        <li><router-link :to="{ name: 'ContractsPriceChanges' }">Prijswijzigingen</router-link></li>
                                    </ul>
                                </slide-up-down>

                                <b-tooltip :label="`${confirmStops} ${confirmStops > 1 ? 'aflopende contracten' : 'aflopend contract'}`" position="is-right" class="exclamation" v-show="!!confirmStops">
                                    <router-link :to="{ name: 'ContractsOverview', query: {'confirmstops': 1} }">
                                        <b-icon icon="exclamation-circle" />
                                    </router-link>
                                </b-tooltip>
                            </li>
                        </ul>

                        <ul class="parent" :class="{ 'active': activeCategory.invoices }">
                            <li class="parent">
                                <div class="text-wrap" @click="toggleCategory('invoices')">
                                    <span class="text has-chevron">Facturen</span>
                                    <b-icon icon="chevron-down" class="arrow"/>
                                    <b-icon icon="file-invoice"/>
                                </div>

                                <slide-up-down :active="activeCategory.invoices" :duration="300">
                                    <ul class="submenu">
                                        <li class="facturen"><router-link :to="{ name: 'InvoicesOverview', params: {type: 'recent'} }">Verzonden</router-link>
                                            <!-- <router-link :to="{ name: 'InvoicesOverview', params: {type: 'recent'}, query: {'action': 1} }" v-if="invoicesNeedsAction" class="float-right">
                                                <b-tag type="is-danger" size="is-small">
                                                    {{ invoicesNeedsAction }}
                                                </b-tag>
                                            </router-link> -->
                                        </li>
                                        <li class="facturen"><router-link :to="{ name: 'InvoicesOverview', params: {type: 'ingepland'} }">Ingepland</router-link></li>
                                        <li class="facturen"><router-link :to="{ name: 'InvoicesOverview', params: {type: 'los'} }" :class="{ 'router-link-active': $route.name == 'CreateInvoiceRecord' }">Losse facturen</router-link></li>
                                        <li class="facturen"><router-link :to="{ name: 'CreditInvoiceOverview' }" :class="{ 'router-link-active': $route.params.type && $route.params.type == 'credit' }">Creditfacturen</router-link></li>
                                        <li class="facturen" v-if="showEscalatedInvoices"><router-link :to="{ name: 'InvoicesOverview', params: {type: 'geescaleerd'} }" :class="{ 'router-link-active': $route.name == 'EscalationRecord' || $route.params.type == 'escalation' }">{{ escalationName == 'escalatie' ? 'Geëscaleerd' : 'Deurwaarder' }}</router-link></li>
                                    </ul>
                                </slide-up-down>

                                <b-tooltip :label="`${invoicesNeedsAction} ${invoicesNeedsAction > 1 ? 'acties vereist' : 'actie vereist'}`" position="is-right" class="exclamation" v-show="!!invoicesNeedsAction">
                                    <router-link :to="{ name: 'InvoicesOverview', params: {type: 'recent'}, query: {'action': 1} }">
                                        <b-icon icon="exclamation-circle" />
                                    </router-link>
                                </b-tooltip>
                            </li>
                        </ul>

                        <router-link :to="{ name: 'CustomersOverview' }" class="parent" :class="{ 'active': activeCategory.customers }">
                            <li class="parent" @click="toggleCategory('customers')">
                                <div class="text-wrap" >
                                    <span class="text">Klanten</span>
                                    <b-icon icon="user-friends"/>
                                </div>
                            </li>
                        </router-link>

                        <router-link :to="{ name: 'ConnectOverview' }" class="parent" :class="{ 'active': activeCategory.access }" v-show="user.role == 'pit' || user.organisation_connect">
                            <li class="parent" @click="toggleCategory('access')">
                                <div class="text-wrap" >
                                    <span class="text">Toegang</span>
                                    <b-icon icon="key"/>
                                </div>
                            </li>
                        </router-link>
                    </div>
                </div>

                <div style="display: flex;height: 180px;flex-direction: column;justify-content: end;padding-bottom: 75px;">
                    <router-link :to="{ name: 'UserSettings' }" class="marginbottom10" v-if="!user.deurwaarder">
                        <b-button type="is-primary" expanded :outlined="$route.name != 'UserSettings'" :inverted="$route.name != 'UserSettings'" @click="toggleCategory(null)" class="marginbottom10" icon-right="cog">Accountinstellingen</b-button>
                    </router-link>

                    <b-button @click="logout" type="is-danger" expanded icon-right="sign-out-alt">Uitloggen</b-button>

                    <div class="version">Versie: {{ version }}</div>
                </div>
            </div>
        </slide-up-down>
    </div>
</template>

<script>
import OrganisationSwitcher from './OrganisationSwitcher.vue'

export default {
    props: {
        user: {
            type: Object,
            required: true
        }
    },

    components: {
        OrganisationSwitcher
    },

    data () {
        return {
            key: 0,
            version: this.$store.state.version,
            mobileNavOpen: true,
            activeCategory: {
                admin: false,
                dashboard: false,
                company: false,
                mail: false,
                discounts: false,
                products: false,
                contracts: false,
                customers: false,
                access: false,
                invoices: false,
                escalatedinvoices: false,
                boxes: false
            }
        }
    },

    computed: {
        cssVars() {
            return {
                '--color1': this.user.organisation_color1,
                '--color2': this.user.organisation_color2
            }
        },

        hideDashboard() {
            let hideDashboard = false

            if(_.has(this.user, 'organisation_settings.dashboard_onlyadmin') && this.user.organisation_settings.dashboard_onlyadmin == 1 && (this.user.role != 'pit' && !this.user.is_admin)){
                hideDashboard = true
            }

            return hideDashboard
        },

        showEscalatedInvoices() {
            let showEscalatedInvoices = false

            if(this.user.role == 'pit' || (this.user.is_admin && _.has(this.user, 'organisation_settings.escalation') && this.user.organisation_settings.escalation == 1)){
                showEscalatedInvoices = true
            }

            if(_.has(this.user, 'organisation_settings.escalation') && this.user.organisation_settings.escalation == 1){
                showEscalatedInvoices = true
            }

            return showEscalatedInvoices
        },

        confirmStops() {
            return this.$store.state.user.confirm_stops
        },

        invoicesNeedsAction() {
            return this.$store.state.user.invoice_needs_action
        },

        // Show box or map menu item
        boxOrMap() {
            if (_.has(this.user, 'settings.open_preference') && (this.user.settings.open_preference == 3 || this.user.settings.open_preference == 4)) {
                return 'map'
            }

            return 'box'
        },

        escalationName() {
            return _.has(this.user, 'organisation_settings.escalation_name') ? this.user.organisation_settings.escalation_name : 'escalatie'
        },

        hasMultipleOrganisations() {
            return this.user && this.user.organisations && Object.keys(this.user.organisations).length > 1
        },

        showDiscountNewBadge() {
            const endDate = new Date('2025-11-09')
            const today = new Date()
            return today <= endDate
        }
    },

    created() {
        if(window.innerWidth < 1024){
            this.mobileNavOpen = false
        }

        window.addEventListener('resize', (event) => {
            if(event.target.innerWidth < 1024){
                if(this.mobileNavOpen){
                    this.mobileNavOpen = false
                }
            } else {
                if(!this.mobileNavOpen){
                    this.mobileNavOpen = true
                }
            }
        }, true)
    },

    mounted () {
        this.setActiveState()
    },

    methods: {
        logout() {
            // Clear all user data from localStorage
            this.$store.commit('clearUserData')
            // Redirect to logout URL
            window.location.href = '/logout'
        },

        toggleCategory(name){
            if(name === null) {
                return;
            }

            if(this.activeCategory[name]){
                this.activeCategory[name] = false
                return
            }

            _.forEach(this.activeCategory, (value, key) => {
                this.activeCategory[key] = false
            })

            this.activeCategory[name] = !this.activeCategory[name]

            setTimeout(() => {
                ++this.key
            }, 350)
        },

        setActiveState(){
            switch(this.$route.name){
                case 'OrganisationsOverview':
                case 'OrganisationsRecord':
                case 'CommunicationOverview':
                    this.toggleCategory('company')
                    return 'company'
                case 'OnlineRentalSettings':
                    this.toggleCategory('company')
                    return 'company'
                case 'LogsOverview':
                    this.toggleCategory('company')
                    return 'company'
                case 'Dashboard':
                    this.toggleCategory('dashboard')
                    return 'dashboard'

                case 'OrganisationRecord':
                case 'UsersOverview':
                case 'CommunicationOverview':
                    this.toggleCategory('company')
                    return 'company'
                case 'CommunicationRecord':
                    this.toggleCategory('company')
                    return 'company'
                case 'BoxesOverview':
                case 'BoxesRecord':
                    this.toggleCategory('boxes')
                    return 'boxes'
                case 'ProductsOverview':
                case 'ProductsRecord':
                    this.toggleCategory('products')
                    return 'products'
                case 'ContractsOverview':
                case 'ContractsRecord':
                case 'ContractsRecordView':
                case 'ContractsTemplates':
                case 'ContractsTemplateRecord':
                case 'ContractsPriceChanges':
                case 'ContractsPriceChangesRecord':
                    this.toggleCategory('contracts')
                    return 'contracts'

                case 'CustomersOverview':
                case 'CustomersRecord':
                    this.toggleCategory('customers')
                    return 'customers'

                case 'InvoicesOverview':
                case 'InvoicesRecord':
                case 'CreditInvoiceOverview':
                case 'CreditInvoiceRecord':
                case 'CreateInvoiceRecord':
                case 'EscalationRecord':
                    if(this.user.deurwaarder){
                        this.toggleCategory('escalatedinvoices')
                        return 'escalatedinvoices'
                    } else {
                        this.toggleCategory('invoices')
                        return 'invoices'
                    }

                case 'AccountsOverview':
                    this.toggleCategory('company')
                    return 'company'
                case 'MailOverview':
                case 'MailRecord':
                    this.toggleCategory('mail')
                    return 'mail'
                case 'ConnectOverview':
                case 'ConnectRecord':
                    this.toggleCategory('access')
                    return 'access'

                case 'DiscountsOverview':
                case 'DiscountsRecord':
                    this.toggleCategory('discounts')
                    return 'discounts'
            }

            setTimeout(() => {
                ++this.key
            }, 350)
        }
    },

    watch: {
        '$route.name' (newVal, oldVal){
            if(newVal != oldVal){
                const toggleCat = this.setActiveState()

                if(!this.activeCategory[toggleCat]){
                    this.toggleCategory(toggleCat)
                }
            }

            // Close navigation on mobile click
            if(window.innerWidth < 1024){
                this.mobileNavOpen = false
            }
        }
    }
}
</script>

<style lang="scss">
$color1: var(--color1);
$color2: var(--color2);

#panel #sidenav {
    ul.parent.active .text-wrap{
        color: $color1;
    }
    ul.parent ul.submenu li a.router-link-active{
        color: $color1;
    }
    ul.parent ul.submenu li a.router-link-active:before{
        background-color:$color1;
    }
    ul.parent ul.submenu li a:before{
        border-color:$color1;
    }

    a.parent.active .text-wrap{
        color: $color1;
    }
}
</style>
